var _defs, _rect, _path, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBirReportIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "gear",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.03 24.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: currentColor;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5419",
    "data-name": "Rectangle 5419",
    className: "cls-1",
    x: 0.01,
    y: 0.01,
    width: 24,
    height: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "receipt_long_FILL0_wght400_GRAD0_opsz24",
    "data-name": "receipt long FILL0 wght400 GRAD0 opsz24",
    className: "cls-2",
    d: "m5.72,22.51c-.84.01-1.64-.32-2.23-.92-.6-.58-.93-1.39-.92-2.23v-3.15h3.15V1.52l1.57,1.57,1.57-1.57,1.57,1.57,1.57-1.57,1.57,1.57,1.57-1.57,1.57,1.57,1.57-1.57,1.57,1.57,1.57-1.57v17.84c.01.84-.32,1.64-.92,2.23-.58.6-1.39.93-2.23.92H5.72Zm12.59-2.1c.28,0,.55-.1.75-.3.2-.2.31-.47.3-.75V4.67H7.82v11.54h9.44v3.15c0,.28.1.55.3.75.2.2.47.31.75.3h0Zm-9.44-11.54v-2.1h6.29v2.1h-6.29Zm0,3.15v-2.1h6.29v2.1h-6.29Zm8.39-3.15c-.28,0-.55-.1-.75-.3-.2-.2-.31-.47-.3-.75,0-.28.1-.55.3-.75.2-.2.47-.31.75-.3.28,0,.55.1.75.3.2.2.31.47.3.75,0,.28-.1.55-.3.75-.2.2-.47.31-.75.3h0Zm0,3.15c-.28,0-.55-.1-.75-.3-.2-.2-.31-.47-.3-.75,0-.28.1-.55.3-.75.2-.2.47-.31.75-.3.28,0,.55.1.75.3.2.2.31.47.3.75,0,.28-.1.55-.3.75-.2.2-.47.31-.75.3h0Zm-11.54,8.39h9.44v-2.1H4.67v1.05c0,.28.1.55.3.75.2.2.47.31.75.31h0Zm-1.05,0h0Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 24.03,
    height: 24.03
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirReportIcon);
export default __webpack_public_path__ + "static/media/bir-report-icon.6dc153ba771c70118dce3db0fadb5a65.svg";
export { ForwardRef as ReactComponent };